import { orderBy } from 'lodash'
import { IShipmentIssueType } from 'types/graphqlTypes'
import { TIssueType } from 'apps/marketplace/pages/shipment-details/components/CreateNewIssueModal/types'

type TShipmentIssueOptions = TIssueType | Partial<IShipmentIssueType>

export const getOrderedShipmentIssueOptions = <T extends TShipmentIssueOptions, U>(
  options: T[],
  mapCallback: (item: T) => U,
  /**
   * Array of fields to sort by
   */
  iteratees: string[],
  /**
   * Array to specify sort order of corresponding values in iteratees
   */
  orders: ('asc' | 'desc')[],
  filterCallback: (item: T) => boolean | undefined = item =>
    !!item.category && item.canManuallyResolve
): U[] => {
  if (!options?.length) return []
  return orderBy(options.filter(filterCallback), iteratees, orders)?.map(mapCallback)
}
